import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

const isRichTextDocument = (value) =>
  value &&
  typeof value === "object" &&
  value.nodeType === "document" &&
  Array.isArray(value.content);

/** Strip tags and collapse whitespace — used to detect empty rich text. */
export const stripHtmlToText = (html) =>
  String(html || "")
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();

/** True when HTML has readable text or meaningful non-text markup. */
export const hasVisibleHtml = (html) => {
  if (!html || !String(html).trim()) return false;
  if (stripHtmlToText(html)) return true;
  return /<(img|iframe|video|figure|table|ul|ol|blockquote)\b/i.test(html);
};

/**
 * Renders a Contentful field that may be a plain HTML string or Rich Text document.
 */
export const contentfulFieldToHtml = (field) => {
  if (!field) return "";
  if (typeof field === "string") return field.trim() ? field : "";
  if (!isRichTextDocument(field)) return "";
  try {
    return documentToHtmlString(field);
  } catch {
    return "";
  }
};

/**
 * Tourism intro from Contentful — prefers `visitBardstown`, falls back to legacy `visitIntro`.
 */
export const resolveVisitBardstownHtml = (fields = {}) => {
  const sources = [fields.visitBardstown, fields.visitIntro].filter(Boolean);
  for (const source of sources) {
    const html = contentfulFieldToHtml(source);
    if (hasVisibleHtml(html)) return html;
  }
  return "";
};
